import React from 'react'
import MakeHomepage from '../make-homepage'

const MakeHomepageSv = () => {
    return <MakeHomepage languageCode="sv" />
}

export default MakeHomepageSv
